var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconColumns = function SvgIconColumns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.125 4.5a1.75 1.75 0 0 0-1.75-1.75H6A1.75 1.75 0 0 0 4.25 4.5v15c0 .966.784 1.75 1.75 1.75h3.375a1.75 1.75 0 0 0 1.75-1.75zm-4.875.25h2.875v14.5H6.25zM19.75 4.5A1.75 1.75 0 0 0 18 2.75h-3.375a1.75 1.75 0 0 0-1.75 1.75v15c0 .966.784 1.75 1.75 1.75H18a1.75 1.75 0 0 0 1.75-1.75zm-4.875.25h2.875v14.5h-2.875z"
  }))));
};
export default SvgIconColumns;